module.exports = __webpack_public_path__ + "static/media/Maax-Bold.10faad3b.ttf";